import styled from 'styled-components'
import { CaptionSmall } from 'components/typography/caption'

export const Wrap = styled(CaptionSmall)`
    transition: color .2s ease-in-out;
    pointer-events: none;
`